import { NgModule } from '@angular/core';
import { RouterModule, Route } from '@angular/router';

// pages
import { LoginPage } from '../pages/login/login';
import { DashBoardPage } from '../pages/dashboard/dashboard';

// members
import { MembersSearchPage } from '../pages/members/search/search';
import { MembersPendingPage } from '../pages/members/pending/pending';

import { MembersDetailPage } from '../pages/members/detail/detail';
import { MembersReportPage } from '../pages/members/report/report';
import { MembersBatchUploadPage } from '../pages/members/batchupload/batchupload';
import { MembersSendpwdPage } from '../pages/members/sendpwd/sendpwd';

//schools 

import { SchoolsSearchPage } from '../pages/schools/search/search';
import { SchoolsReportPage } from '../pages/schools/report/report';

import { SchoolsDetailPage } from '../pages/schools/detail/detail';

//teachers 

import { TeachersSearchPage } from '../pages/teachers/search/search';
import { TeachersReportPage } from '../pages/teachers/report/report';

import { TeachersDetailPage } from '../pages/teachers/detail/detail';

//email templates

import { EmailTplsListPage } from '../pages/configs/email-tpls/list/list';
import { EmailTplsDetailPage } from '../pages/configs/email-tpls/detail/detail';

// users
import { UsersPage } from '../pages/users/users';
import { UsersDetailPage } from '../pages/users/detail/detail';

// guards
import { AuthGuard } from '../guards/auth.guard';

const routes: Route[] = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginPage },

	{ path: '', children: [
	
    { path: 'dashboard', component: DashBoardPage },



    { path: 'members/search', component: MembersSearchPage },
    { path: 'members/pending', component: MembersPendingPage },

    { path: 'members/create', component: MembersDetailPage },
    
    { path: 'members/edit/:id', component: MembersDetailPage },

    { path: 'members/view/:id', component: MembersDetailPage },
    { path: 'members/report', component: MembersReportPage },
    { path: 'members/batchupload', component: MembersBatchUploadPage },
    { path: 'members/sendpwd', component: MembersSendpwdPage },


    { path: 'schools/search', component: SchoolsSearchPage },
    { path: 'schools/report', component: SchoolsReportPage },

    { path: 'schools/create', component: SchoolsDetailPage },
    
    { path: 'schools/edit/:id', component: SchoolsDetailPage },

    { path: 'schools/view/:id', component: SchoolsDetailPage },

    { path: 'teachers/search', component: TeachersSearchPage },
    { path: 'teachers/report', component: TeachersReportPage },

    { path: 'teachers/create', component: TeachersDetailPage },
    
    { path: 'teachers/edit/:id', component: TeachersDetailPage },

    { path: 'teachers/view/:id', component: TeachersDetailPage },


    { path: 'email-tpls/list', component: EmailTplsListPage },
    { path: 'email-tpls/create', component: EmailTplsDetailPage },
    
    { path: 'email-tpls/edit/:id', component: EmailTplsDetailPage },

    { path: 'email-tpls/view/:id', component: EmailTplsDetailPage },

    { path: 'users/create', component: UsersDetailPage },
    { path: 'users/edit/:id', component: UsersDetailPage },
    { path: 'users', component: UsersPage },

  ], canActivate: [ AuthGuard ]},
];

@NgModule({
	imports: [ RouterModule.forRoot(routes) ],
	exports: [ RouterModule ]
})
export class AppRoutesModule {}



// WEBPACK FOOTER //
// ./src/app/app.routes.module.ts